<template>
	<div>
		<div>
			<van-nav-bar title="" left-arrow @click-left="onClickLeft">
				<template #left>
					<van-icon name="arrow-left" size="22" color="#fff" />
				</template>
			</van-nav-bar>
		</div>
		<div class="feiziInfo">
			<div class="topInfo">
				<div><span>{{ data.xuanfei_name }}</span></div>
				<div style="color: #6b22b3; font-size: 3vw; margin: 10px 0;">
					{{$t("index.height")}}:{{ data.hight }} {{$t("index.bust")}}：{{ data.bust }}
				</div>

				<div style="width: 50%;">
					<div class="item" v-for="(item,index) in data.flagArray" :key="index">{{item}}</div>
				</div>
				<div>
					<span style="color: rgb(107, 34, 179); font-size: 14px;">{{$t("index.toll")}}：</span>
					<van-rate v-model="data.number" readonly color="#ffd21e" size="18px" />
				</div>
				<div class="yuyueBox" @click="getUserGameList">{{$t("index.i_want_her")}}</div>
			</div>
			<div style="padding-bottom: 4vw; background-color: #ebedf0;"></div>

			<div class="cenInfo">
				<div>
					<div class="imgswiper">
						<div v-for="(i,index) in data.img_url" :key="'img-'+index"
							style="min-width: 100px; width: 100px; height: 100px; margin-right: 10px;">
							<div @click="onClickMedia(index, 'img')"
								:class="['imgI van-image', { active: currentIndex === index && currentType === 'img' }]"
								style="width: 100px; height: 100px;">
								<img :src="i" style="width: 100%; height: 100%; object-fit: cover; display: block;" />
							</div>
						</div>

						<div v-if="data.pvideo"
							style="min-width: 100px; width: 100px; height: 100px; margin-right: 10px; position: relative;">
							<div @click="onClickMedia(0, 'video')"
								:class="['imgI van-image', { active: currentType === 'video' }]"
								style="width: 100px; height: 100px; background: #000; display: flex; align-items: center; justify-content: center; border-radius: 4px;">
								<van-icon name="play-circle-o" size="40" color="#fff" />
							</div>
						</div>
					</div>

					<div v-show="currentType === 'img'" class="van-image"
						style="width: 100%; height: 635px; background: #f7f8fa;">
						<img v-if="data.img_url && data.img_url.length > 0" :src="data.img_url[currentIndex]"
							style="width: 100%; height: 100%; object-fit: cover; display: block;" />
					</div>

					<div v-show="currentType === 'video'" class="movie-video"
						style="width: 100%; height: 635px; background: #000;">
						<video ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered" controls
							preload="auto" style="width: 100%; height: 100%;">
						</video>
					</div>
				</div>
			</div>

			<div style="padding-bottom: 2vw; background-color: #ebedf0;"></div>
			<div class="btmInfo" v-if="data.jianjie">
				<div style="color: rgb(42, 20, 104); margin-bottom: 10px; font-weight: bold;">introduce</div>
				<div style="color: rgb(83, 69, 137);">{{ data.jianjie }}</div>
			</div>
		</div>
		<div style="padding-bottom: 2vw; background-color: #ebedf0;"></div>
	</div>
</template>

<script>
	import videojs from 'video.js';
	import 'videojs-contrib-hls'; // 【极其关键】：必须引入这个插件，才能解析 m3u8！
	import 'video.js/dist/video-js.css';

	export default {
		data() {
			return {
				data: {},
				currentIndex: 0,
				currentType: 'img', // 当前展示的是图片('img')还是视频('video')
				player: null,
			};
		},
		methods: {
			getxuanfeidata() {
				this.$http({
					method: 'get',
					url: 'xuanfeidata',
					data: {
						id: this.$route.query.id
					}
				}).then(res => {
					this.data = res.data;
					const lanng = localStorage.getItem("lang");

					const parts = this.data.flag.split('|')
					lanng == 'zh' ? this.data.flag = parts[0] : lanng == 'en' ? this.data.flag = parts[1] :
						lanng == 'ja' ? this.data.flag = parts[2] : this.data.flag = parts[3]
					this.data.flagArray = this.data.flag.split('，');

					// 确保每次进去默认选中第一张图
					this.currentType = 'img';
					this.currentIndex = 0;
				});
			},

			// 媒体点击切换逻辑
			onClickMedia(index, type) {
				this.currentType = type;

				if (type === 'img') {
					this.currentIndex = index;
					// 切换回图片时，如果视频在播放则暂停
					if (this.player) {
						this.player.pause();
					}
				} else if (type === 'video') {
					// 去掉图片的选中高亮
					this.currentIndex = -1;

					// 等待 Vue 将 v-show 切换为 true，容器真实显示出来之后，再初始化播放器
					this.$nextTick(() => {
						if (!this.player) {
							this.player = videojs(this.$refs.videoPlayer, {
								controls: true,
								preload: 'auto',
								fluid: true
							});
						}

						// 智能判断视频格式，如果是 m3u8 则指定解析类型
						let videoType = 'video/mp4';
						if (this.data.pvideo && this.data.pvideo.indexOf('.m3u8') !== -1) {
							videoType = 'application/x-mpegURL';
						}

						if (this.data.pvideo) {
							// 修复点2：必须像 PlayVideo.vue 一样，传入一个包裹着对象的数组！
							this.player.src([{
								src: this.data.pvideo,
								type: videoType
							}]);
						}
					});
				}
			},

			onClickLeft() {
				this.$router.go(-1)
			},

			getUserGameList() {
				this.$http({
					method: 'get',
					url: 'user_get_game_list'
				}).then(res => {
					if (res.code === 200) {
						this.$toast('Please complete the activation process first.');
						this.list = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			}
		},
		created() {
			this.getxuanfeidata();
		},
		mounted() {
			window.scrollTo(0, 0);
		},
		beforeDestroy() {
			// 离开页面时正常销毁播放器实例
			if (this.player) {
				this.player.dispose();
			}
		},
	};
</script>

<style scoped lang="less">
	.van-nav-bar {
		background: linear-gradient(30deg, #7d76ef, #d63f8c) !important;
	}

	.van-nav-bar .van-icon {
		color: #fff !important;
	}

	.feiziInfo {
		background: #ebedf0;
	}

	.topInfo {
		position: relative;
		padding: 4vw 40px;
		background: #fff;
	}

	.feiziInfo .topInfo div:first-child span:first-child {
		color: #2c1868;
		font-size: 5vw;
	}

	.topInfo .item {
		background: linear-gradient(50deg, #9b54ca, #e6557f);
		color: #fff;
		display: inline-block;
		border-radius: 20px;
		margin-right: 30px;
		font-size: 24px;
		padding: 16px;
		margin-bottom: 30px;
	}

	.yuyueBox {
		position: absolute;
		right: 4vw;
		bottom: 40px;
		color: #fff;
		padding: 20px 30px;
		background: linear-gradient(20deg, #e73266, #ee5380);
		border-radius: 7vw;
	}

	.cenInfo {
		padding: 4vw 20px;
		background: #fff;
	}

	.imgswiper {
		width: 100%;
		overflow-x: scroll;
		margin: 4vw 0;
		display: flex;
		flex-wrap: nowrap;
	}

	.imgswiper .active {
		border: 10px solid #e54878;
		box-sizing: border-box;
	}

	.btmInfo {
		padding: 4vw 40px;
		background: #fff;
	}
</style>